import React, { useState } from 'react';
import './PageHeader.css'
import './AddForm.css'
import Btn from './Btn';
import { supabase } from '../../supabase';


const UserPageHeader = (props) => {
    const [form, showForm] = useState(false);
    const [userName, setUserName] = useState("")
    const [userMail, setuserMail] = useState("")
    const [userRole, setUserRole] = useState("")

    const AddFormHandler = () => {
        showForm(prev => !prev);
    }

    const createEvent = async () => {
        const res = await supabase.from("Users").insert([{
            'user_Name':userName,
            'user_Email':userMail,
            'role':userRole,
        }])

        console.log(res)
    }

    return ( 
        <>
        <div className={props.PageHeaderStyle}>
            <div className='HeaderText'>
                <p className='HeaderTitle'>
                    {props.HeaderTitle}
                </p>
                <p className='HeaderSub'>
                    {props.HeaderSub}
                </p>
            </div>

            <Btn onClick={AddFormHandler} BtnStyle="AddBtn" BtnText={props.BtnText}/>
        </div>
        <div className={form ? 'AddFormShown' : 'AddForm'}>
            <p className='FormName'>
                {props.FormName}
            </p>

            <form>
                <div className='Input'>
                    <label>User name</label>
                    <input type="text" onChange={(e) => setUserName(e.target.value)} />
                </div>
                <div className='Input'>
                    <label>User Role</label>
                    <input type="text" onChange={(e) => setUserRole(e.target.value)}/>
                </div>
                <div className='Input'>
                    <label>User Email</label>
                    <input type="text" onChange={(e) => setuserMail(e.target.value)}/>
                </div>
            </form>
            <div className='FormBtns'>
                <Btn BtnStyle="FormAddBtn" BtnText="Add Event" onClick={createEvent}/>
                <Btn BtnStyle="FormCancelBtn" BtnText="Cancel" onClick={() => showForm(false)}/>
            </div>
        </div>
        </>
     );
}
 
export default UserPageHeader;